import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { CaseStudyArticle } from "@/components/resources/CaseStudyArticle";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import body from "../../content/resources/llantas-cavazos-shopify-migration-case-study.es.md?raw";

const PATH = "/es/recursos/caso-llantas-cavazos-migracion";
const ALT = "/resources/llantas-cavazos-migration-case-study";
const TITLE = "Cómo Llantas Cavazos migró más de 8,000 SKUs a Shopify sin frenar la operación";
const META_TITLE = "Caso Llantas Cavazos: Migración a Shopify · Shugert";
const DESCRIPTION = "Cómo Llantas Cavazos migró más de 8,000 SKUs a Shopify con búsqueda por medida, inventario sincronizado, redirects SEO y más del 90% del tráfico orgánico conservado.";
const PUBLISHED = "2026-07-30T14:53:00.000Z";
const MODIFIED = "2026-07-30T14:53:00.000Z";

const SOURCES = [
  { label: "Acerca de Llantas Cavazos", publisher: "Llantas Cavazos", href: "https://llantascavazos.com/pages/nosotros" },
  { label: "Sucursales de Llantas Cavazos", publisher: "Llantas Cavazos", href: "https://llantascavazos.com/pages/sucursales" },
  { label: "Migrar a Shopify", publisher: "Centro de ayuda de Shopify", href: "https://help.shopify.com/es/manual/migrating-to-shopify" },
  { label: "Gestionar el inventario", publisher: "Centro de ayuda de Shopify", href: "https://help.shopify.com/es/manual/products/inventory" },
  { label: "Migraciones con cambios de URL", publisher: "Google Search Central", href: "https://developers.google.com/search/docs/crawling-indexing/site-move-with-url-changes?hl=es" },
  { label: "Especificación de datos de producto", publisher: "Ayuda de Google Merchant Center", href: "https://support.google.com/merchants/answer/15624859?hl=es" },
  { label: "Descripción general de Cloudflare Workers", publisher: "Cloudflare Developers", href: "https://developers.cloudflare.com/workers/" },
];

const RELATED = [
  { label: "Cronograma de migración Shopify para marcas establecidas", href: "/es/recursos/shopify-migration-timeline" },
  { label: "Redirects 301 para catálogos Shopify grandes", href: "/es/recursos/shopify-301-redirects-large-catalogs" },
  { label: "Explorar todos los recursos de migración", href: "/es/recursos/migracion" },
  { label: "Servicio de migración a Shopify", href: "/es/migracion-shopify" },
];

export const Route = createFileRoute("/es/recursos/caso-llantas-cavazos-migracion")({
  loader: async () => {
    await setEdgeHtmlCache();
  },
  head: () =>
    buildHead({
      locale: "es",
      title: META_TITLE,
      description: DESCRIPTION,
      path: PATH,
      altPath: ALT,
      type: "article",
      author: "Samuel Noriega",
      articleAuthor: "Samuel Noriega",
      articleSection: "Caso de migración",
      publishedTime: PUBLISHED,
      modifiedTime: MODIFIED,
      jsonLd: [
        articleJsonLdForPillar({
          title: TITLE,
          description: DESCRIPTION,
          path: PATH,
          publishedTime: PUBLISHED,
          modifiedTime: MODIFIED,
          section: "Caso de migración",
        }),
        breadcrumbJsonLd([
          { name: "Inicio", path: "/es" },
          { name: "Recursos", path: "/es/recursos" },
          { name: "Migración", path: "/es/recursos/migracion" },
          { name: "Caso Llantas Cavazos", path: PATH },
        ]),
      ],
    }),
  component: () => (
    <SiteShell>
      <CaseStudyArticle
        locale="es"
        path={PATH}
        title={TITLE}
        excerpt="Cómo una llantera establecida de Monterrey migró más de 8,000 SKUs a Shopify, añadió búsqueda por medida y sincronización de inventario, y conservó más del 90% del tráfico orgánico durante la primera semana."
        body={body}
        updated="julio de 2026"
        publishedAt={PUBLISHED}
        modifiedAt={MODIFIED}
        readingMinutes={18}
        focus="Cómo Llantas Cavazos rediseñó datos de producto, búsqueda por medida, sincronización de inventario, continuidad SEO, historial de clientes y lanzamiento como una sola migración a Shopify."
        audience="Líderes ecommerce, distribuidores, retailers automotrices y operadores que planean migrar miles de productos definidos por especificaciones y con demanda orgánica existente."
        sources={SOURCES}
        related={RELATED}
      />
    </SiteShell>
  ),
});
